<template>
    <div>
        <!-- Password input field -->
        <div :class="passwordInputClass">
            <label
                class="input__label"
                v-if="showLabel"
                :class="{ 'required-input': mandatory }"
                :for="`password_${_uid}`"
                v-text="label || $t('ACCOUNT_FORM_PASSWORD')">
            </label>
            <input
                autocapitalize="off"
                :id="`password_${_uid}`"
                class="input__field input__password"
                :name="`password_${_uid}`"
                :placeholder="placeholder"
                :type="passwordInputType"
                @blur="onBlur"
                v-model="password">
            <img :src="getImgUrl"
                class="input__show_password"
                :class="{noLabel: !showLabel}"
                alt="Show/hide password"
                @click="showHidePassword">
            <!-- Validation -->
            <p class="input__message"
               v-if="message"
               v-html="message">
            </p>
            <p class="input__message"
               v-else-if="!isSecure"
               v-html="$t(errorHandler.get('password'))">
            </p>
        </div>
    </div>
</template>

<script>
import PasswordService from '@/services/cms/PasswordService';
import ErrorResponseHandler from '@/helpers/ErrorResponseHandler';

export default {
    name: 'PasswordField',
    props: {
        label: {
            default: null,
            type: String,
        },
        requireStrongPassword: {
            default: false,
            type: Boolean,
        },
        value: {
            type: String,
        },
        message: {
            required: false,
            type: String,
            default: null,
        },
        isValid: {
            default: true,
            type: Boolean,
        },
        mandatory: {
            default: false,
            type: Boolean,
        },
        showLabel: {
            default: true,
            type: Boolean,
        },
        noPadding: {
            default: false,
            type: Boolean,
        },
        placeholder: {
            default: '',
            type: String,
        },
    },
    data() {
        return {
            password: this.value,
            showPassword: false,
            errorHandler: new ErrorResponseHandler(),
        };
    },
    computed: {
        passwordInputClass() {
            if (this.value === null && this.isValid === true) {
                return `input ${this.noPadding ? 'no-padding' : ''}`;
            }

            return !this.isSecure ? `input input--invalid ${this.noPadding ? 'no-padding' : ''}` : `input input--success ${this.noPadding ? 'no-padding' : ''}`;
        },

        passwordInputType() {
            return this.showPassword ? 'text' : 'password';
        },

        isSecure() {
            return !this.errorHandler.has('password') && this.isValid;
        },
        getImgUrl() {
            if (!this.isSecure) {
                return require('@/assets/images/decoration/icons/show-password-red.svg');
            }
            return require('@/assets/images/decoration/icons/show-password.svg');
        },
    },
    methods: {
        showHidePassword() {
            this.showPassword = !this.showPassword;
        },
        validatePassword(value) {
            PasswordService.isPasswordNotBlacklisted(value)
                .then(() => this.errorHandler.reset())
                .catch(error => this.errorHandler.setResponse(error.response.data));
        },
        onBlur(e) {
            const value = e.target.value;
            this.password = value;
            if (this.requireStrongPassword) {
                this.validatePassword(this.password);
            }
            this.$emit('input', value);
        },
    },
    watch: {
        password(val) {
            if (!this.requireStrongPassword) {
                this.$emit('input', val);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.noLabel {
    top: 10px;
    padding: 0;
}
.input__field {
    &::placeholder {
        color: #b3b3b3;
    }
}
.no-padding {
    padding: 0;
}
</style>
